import { render, staticRenderFns } from "./ServersTable.vue?vue&type=template&id=20f2a0ac&scoped=true&"
import script from "./ServersTable.vue?vue&type=script&lang=js&"
export * from "./ServersTable.vue?vue&type=script&lang=js&"
import style0 from "./ServersTable.vue?vue&type=style&index=0&id=20f2a0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2a0ac",
  null
  
)

export default component.exports